export default __webpack_public_path__ + "static/icon-550f0389ecac040154830e756286a553.png";